import React from 'react'

interface CharCountProps {
  current: number
  max: number
  /** Characters required before current length is considered valid */
  min?: number
  style?: React.CSSProperties
}

export const CharCount: React.FC<CharCountProps> = ({ current, max, min, style }) => {
  const remaining = max - current
  const tooShort  = min !== undefined && current < min
  const tooLong   = remaining < 0

  const color = tooShort
    ? 'var(--status-error)'
    : tooLong
    ? 'var(--status-error)'
    : remaining <= Math.floor(max * 0.1)
    ? 'var(--status-warning, #f97316)'
    : 'var(--text-muted)'

  const label = tooShort
    ? `${min! - current} more character${min! - current !== 1 ? 's' : ''} needed`
    : `${current}/${max}`

  return (
    <span style={{ fontSize: '0.72rem', color, textAlign: 'right', display: 'block', ...style }}>
      {label}
    </span>
  )
}
